(function () {
  'use strict';

  if (customElements.get('cart-reward-recommendations')) return;

  class CartRewardRecommendations extends HTMLElement {
    static mergeCards(cardGroups, excludedIds, limit) {
      const seen = new Set();
      const merged = [];

      cardGroups.forEach(function (cards) {
        cards.forEach(function (card) {
          const productId = String(card.dataset.productId || '');
          if (!productId || excludedIds.has(productId) || seen.has(productId)) return;

          seen.add(productId);
          if (merged.length < limit) merged.push(card);
        });
      });

      return merged;
    }

    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this.addEventListener('click', this.handleClick.bind(this));
      this.load();
    }

    parseIds(value) {
      return String(value || '')
        .split(',')
        .map(function (id) { return id.trim(); })
        .filter(Boolean);
    }

    recommendationUrl(productId) {
      const endpoint = this.dataset.url || '/recommendations/products';
      const separator = endpoint.indexOf('?') === -1 ? '?' : '&';
      return endpoint + separator + new URLSearchParams({
        section_id: this.dataset.sectionId || 'cart-reward-recommendations',
        product_id: productId,
        limit: this.dataset.requestLimit || '6',
        intent: 'related',
      }).toString();
    }

    async load() {
      if (this._loading || this.dataset.loaded === 'true') return;

      const seedIds = Array.from(new Set(this.parseIds(this.dataset.seedProductIds))).slice(0, 3);
      if (seedIds.length === 0) return;

      this._loading = true;

      try {
        const groups = await Promise.all(seedIds.map(async (productId) => {
          const response = await fetch(this.recommendationUrl(productId));
          if (!response.ok) return [];

          const html = await response.text();
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          return Array.from(parsed.querySelectorAll('.cart-reward-recommendations__card'));
        }));

        const excludedIds = new Set(this.parseIds(this.dataset.cartProductIds));
        const cards = CartRewardRecommendations.mergeCards(groups, excludedIds, 6);
        const track = this.querySelector('.cart-reward-recommendations__track');

        if (!track || cards.length === 0) return;

        track.replaceChildren.apply(track, cards);
        this.hidden = false;
        this.dataset.loaded = 'true';
      } catch (error) {
        console.error('[CartRecommendations] could not load recommendations', error);
      } finally {
        this._loading = false;
      }
    }

    handleClick(event) {
      const nextButton = event.target.closest('.cart-reward-recommendations__next');
      if (nextButton) {
        const track = this.querySelector('.cart-reward-recommendations__track');
        if (track) track.scrollBy({ left: track.clientWidth * 0.75, behavior: 'smooth' });
        return;
      }

      const addButton = event.target.closest('.cart-reward-recommendations__add');
      if (addButton) this.addProduct(addButton);
    }

    async addProduct(button) {
      if (button.getAttribute('aria-disabled') === 'true') return;

      const variantId = button.dataset.variantId;
      const cartDrawer = document.querySelector('cart-drawer');
      if (!variantId || !cartDrawer) return;

      const label = button.querySelector('.cart-reward-recommendations__add-label');
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
      if (label) label.textContent = 'Adding…';

      try {
        const config = typeof fetchConfig === 'function'
          ? fetchConfig('javascript')
          : { method: 'POST', headers: { Accept: 'application/javascript' } };
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        formData.append('sections', cartDrawer.getSectionsToRender().map(function (section) { return section.id; }));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        const cartAddUrl = window.routes && window.routes.cart_add_url
          ? window.routes.cart_add_url
          : '/cart/add.js';
        const response = await fetch(cartAddUrl, config);
        const data = await response.json();

        if (!response.ok || data.status) throw new Error(data.description || 'Unable to add product');

        cartDrawer.renderContents(data);

        const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        const cartResponse = await fetch(root + 'cart.js');
        const cart = await cartResponse.json();
        document.dispatchEvent(new CustomEvent('cart:changed', {
          bubbles: false,
          detail: { cartobject: cart },
        }));
      } catch (error) {
        console.error('[CartRecommendations] add failed', error);
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
        if (label) label.textContent = 'Try again';
      }
    }
  }

  customElements.define('cart-reward-recommendations', CartRewardRecommendations);
})();
